/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon32Regular = forwardRef('ArrowDCornerRightDownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M21 10a5 5 0 0 0-5-5H4a1 1 0 0 0 0 2h12a3 3 0 0 1 3 3v15.586l-7.293-7.293a1 1 0 0 0-1.414 1.414l7.338 7.338a3.35 3.35 0 0 0 4.738 0l7.338-7.338a1 1 0 0 0-1.414-1.414L21 25.586V10Z" })));
});
